import { Dialog, Transition } from '@headlessui/react';
import { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import { UpgradePlanText } from '../../../Layout/app/frame/shared/upgrade-text';
import { getLocalStorage, getWorkspace, handleOpenEmail, isSafari } from '../../../../utils';
import {
  useAccountHasFreePlan,
  useAccountHasPlanPaid,
  useAccountHasStarterPlan,
  useAccountHasTrialPlanPaid,
  useForceCloseUploading,
  useIsShortenedFile,
  useSheetName,
  useShowErrorModalComingSoon,
  useShowsSheetsScreen
} from '../../../../lib/store/dashboard.store';
import { useAccountHasLillyPaid } from '../../../../lib/store/frame.store';
import { VideoModal } from './video-popup';
import { useFileUploadedState } from '../../../../lib/store/settings.store';
import ReactHtmlParser from 'react-html-parser';
import {
  useHasAccountRestrictions,
  useNavigationMenu,
  useNewLillyClaim,
  useSetGenericError
} from '../../../../lib/store/v3/layout';
import { useLocation, useNavigate } from 'react-router-dom';

export const ModalError = ({
  openModal,
  setOpenModal,
  error,
  headerTextForNoPlan,
  isGenericError,
  handleClickUpgrade,
  headersError,
  setHeaderError,
  isSAVFile,
  setIsSAVFile,
  setOpenUploadModal
}: {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  error?: any;
  headerTextForNoPlan?: string;
  isGenericError?: boolean;
  handleClickUpgrade?: any;
  headersError?: boolean;
  setHeaderError?: any;
  isSAVFile?: boolean;
  setIsSAVFile?: any;
  setOpenUploadModal?: any;
}) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const isSafariBrowser = isSafari();
  const accountPaid = useAccountHasPlanPaid((state: any) => state.accountPaid);
  const newLillyClaim = useNewLillyClaim((state: any) => state.newLillyClaim);
  const trialAccountPaid = useAccountHasTrialPlanPaid((state: any) => state.trialAccountPaid);
  const freeAccount = useAccountHasFreePlan((state: any) => state.freeAccount);
  const accountLillyPaid = useAccountHasLillyPaid((state: any) => state.accountPaid);
  const starterAccount = useAccountHasStarterPlan((state: any) => state.accountPaid);
  const fileShortened: any = getLocalStorage('file-shortened') ?? false;
  const showsMaxRowsRestriccion: any = getLocalStorage('max-rows-restric') ?? false;
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const setShowSheetsScreen = useShowsSheetsScreen((state: any) => state.setShow);
  const setSheetSelected = useSheetName((state: any) => state.setName);
  const setForceCloseUpload = useForceCloseUploading((state: any) => state.setForce);
  const setFileUploadedState = useFileUploadedState((state: any) => state.setFileUploadedState);
  const showModalErrorComingSoon = useShowErrorModalComingSoon(
    (state: any) => state.showModalError
  );
  const setShowModalError = useShowErrorModalComingSoon((state: any) => state.setShowModalError);
  const hasAccountRestrictions = useHasAccountRestrictions((state: any) => state.hasRestrictions);
  const setHasRestrictions = useHasAccountRestrictions((state: any) => state.setHasRestrictions);
  const showGenericError = useSetGenericError((state: any) => state.showGenericError);
  const setNavigation = useNavigationMenu((state: any) => state.setNavigation);
  const navigate = useNavigate();
  const location = useLocation().pathname;
  const setShowGenericError = useSetGenericError((state: any) => state.setShowGenericError);

  const cleanStatusForShowingGenericError = () => {
    const workspaceid = getWorkspace(location);
    setNavigation('distributions');
    navigate(`/distributions/${workspaceid}`);
    setShowGenericError(false);
  };

  const closeIcon = () => {
    localStorage.removeItem('max-rows-restric');
    setHasRestrictions(false);
    setShowModalError(false);
    setOpenModal(false);
    localStorage.removeItem('file-shortened');
    if (setHeaderError) setHeaderError(false);
    if (setIsSAVFile) setIsSAVFile(false);
    if (isSAVFile) {
      setOpenUploadModal(false);
      setShowSheetsScreen(false);
      localStorage.removeItem('endUploadLoader');
      setSheetSelected('');
      setForceCloseUpload(true);
      setFileUploadedState(false);
    }

    if (showGenericError) {
      cleanStatusForShowingGenericError();
    }
  };

  const closeChatAIcon = () => {
    setOpenModal(false);
    cleanStatusForShowingGenericError();
  };

  const handleClickWatch = () => {
    setShowVideoModal(true);
  };

  const ContactInfo = () => {
    return (
      <div className="flex flex-row gap-1 pt-2 pb-3 justify-center items-center bg-[#D9D9D933]">
        <span className="text-[#364152]">Help with formatting:&nbsp;&nbsp;</span>
        <span onClick={handleClickWatch} className="text-[#E7811D] cursor-pointer ml-1">
          Watch
        </span>
        <span className="text-[#364152] mr-0.5">this clip</span>
        <span className="text-[#364152]">&nbsp; | &nbsp;</span>
        <span onClick={handleOpenEmail} className="text-[#E7811D] cursor-pointer ml-[3px]">
          Contact
        </span>
        <span className="text-[#364152]"> our team</span>
      </div>
    );
  };

  return (
    <>
      {showGenericError ? (
        <>
          <div
            className=" absolute -top-14 right-0 h-full w-full  bg-opacity-75 transition-opacity flex items-center justify-center"
            onClick={openModal ? closeChatAIcon : undefined}>
            <div>
              <div
                className={`min-w-[640px] 2xl:w-6/12 w-[54%] max-w-[685px] relative transform overflow-hidden rounded-[25px] bg-white text-left transition-all shadow-[0_5px_30px_-1px_rgba(0,0,0,0.25)]`}>
                <div className="flex flex-col font-montserrat">
                  <div className="cursor-pointer flex justify-end mt-5 mr-8 pt-2">
                    <img
                      src="/icons/cancel.svg"
                      alt="Cancel icon"
                      className="h-4"
                      onClick={closeIcon}
                    />
                  </div>

                  <div className="bg-white" onClick={(e) => e.stopPropagation()}>
                    <>
                      <div className={`pb-7 flex flex-col justify-center gap-6 text-center`}>
                        <div className="text-[#364152] pb-16 flex flex-col gap-2">
                          <>
                            <span className="font-bold text-[#364152] pt-4">
                              Oops! Something went wrong
                            </span>
                            <span className="pt-5 text-[#364152]">
                              Please try again later or contact
                            </span>
                            <span
                              className="text-[#1C8CA6] -mt-1 font-semibold cursor-pointer underline underline-offset-4"
                              onClick={handleOpenEmail}>
                              support@drumroll.ai
                            </span>{' '}
                          </>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <Transition.Root show={openModal} as={Fragment}>
            <Dialog
              as="div"
              className={`${showVideoModal ? '' : 'z-[1000]'} relative`}
              data-testid="modal-root"
              onClose={() => false}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0">
                <div className={`fixed inset-0 bg-white/80 bg-opacity-75 transition-opacity`} />
              </Transition.Child>

              <div className="fixed inset-0 overflow-auto font-montserrat">
                <div
                  className={`${
                    (window.outerWidth <= 820 || window.innerWidth <= 820) && isSafariBrowser
                      ? 'overflow-auto'
                      : ''
                  } flex items-end justify-center p-4 text-center sm:items-center 2xl:min-h-full 2xl:-mt-16 mt-24`}>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <Dialog.Panel
                      className={`${
                        hasAccountRestrictions
                          ? 'w-[28%]'
                          : 'min-w-[640px] 2xl:w-6/12 w-[54%] max-w-[685px]'
                      }  relative transform overflow-hidden rounded-[25px] bg-white text-left transition-all shadow-[0_5px_30px_-1px_rgba(0,0,0,0.25)]`}>
                      <div className="flex flex-col font-montserrat">
                        <div className="cursor-pointer flex justify-end mt-5 mr-8 pt-2">
                          <img
                            src="/icons/cancel.svg"
                            alt="Cancel icon"
                            className="h-4"
                            onClick={closeIcon}
                          />
                        </div>

                        {showModalErrorComingSoon ? (
                          <div className="pt-14 pb-[8rem] text-center">
                            <span className="text-[#364152] font-bold">
                              This feature is coming soon
                            </span>
                          </div>
                        ) : (
                          <>
                            {hasAccountRestrictions ? (
                              <div className="mb-14">
                                <span className="">
                                  <UpgradePlanText
                                    headerTextForNoPlan={headerTextForNoPlan}
                                    handleClickUpgrade={handleClickUpgrade}
                                    classname={'flex justify-center flex-row pb-2 pt-2.5 gap-1'}
                                    noRocketIcon={false}
                                    customText={`<span class='font-semibold text-sm'>to access this and other features</span>`}
                                    isShortened={true}
                                    fontSize="text-sm"
                                  />
                                </span>
                              </div>
                            ) : headersError ? (
                              <>
                                <div className="flex flex-col justify-center gap-6 text-center pb-10">
                                  <span className="font-bold text-base text-[#364152] pt-4">
                                    We encountered a problem
                                  </span>
                                  <div className="flex flex-row gap-4 justify-center pb-16">
                                    {/* <div>
                                  <img src="/icons/warning-upload.svg" className="" alt="Candle" />
                                </div> */}
                                    <span className="font-normal text-base text-[#364152]">
                                      {headerTextForNoPlan && headerTextForNoPlan?.length > 0 ? (
                                        <>{ReactHtmlParser(headerTextForNoPlan)}</>
                                      ) : (
                                        <>
                                          {' '}
                                          The <b>header</b> is missing or not formatted correctly
                                        </>
                                      )}
                                    </span>
                                  </div>

                                  <ContactInfo />
                                </div>
                              </>
                            ) : fileShortened ||
                              (headerTextForNoPlan && headerTextForNoPlan?.length > 0) ? (
                              !(
                                accountPaid ||
                                accountLillyPaid ||
                                trialAccountPaid ||
                                newLillyClaim
                              ) || freeAccount ? (
                                <>
                                  <div className="flex flex-col justify-center gap-6 text-center pb-12">
                                    <span className="font-bold text-base text-[#364152] pt-4">
                                      We encountered a problem
                                    </span>
                                    <div
                                      className={`${
                                        headerTextForNoPlan &&
                                        headerTextForNoPlan?.length > 0 &&
                                        !showsMaxRowsRestriccion
                                          ? 'pt-3'
                                          : 'pt-9'
                                      } flex flex-row gap-4 justify-center`}>
                                      <div>
                                        <img
                                          src="/icons/candle-upgrade.svg"
                                          className=""
                                          alt="Candle"
                                        />
                                      </div>
                                      <span className="font-normal text-base text-[#364152]">
                                        {headerTextForNoPlan &&
                                        headerTextForNoPlan?.length > 0 &&
                                        !showsMaxRowsRestriccion ? (
                                          <>{headerTextForNoPlan}</>
                                        ) : (
                                          <>
                                            Your plan allows up to{' '}
                                            {!accountPaid &&
                                            !starterAccount &&
                                            !trialAccountPaid &&
                                            !newLillyClaim
                                              ? '100 rows and 20 columns'
                                              : starterAccount
                                              ? '100.000 rows'
                                              : '10.000.000 rows'}
                                          </>
                                        )}
                                      </span>
                                    </div>

                                    {headerTextForNoPlan && headerTextForNoPlan?.length > 0 && (
                                      <span className="font-bold text-base text-[#364152] pb-6">
                                        Let’s fix this!
                                      </span>
                                    )}

                                    <div
                                      className={`${
                                        headerTextForNoPlan && headerTextForNoPlan?.length > 0
                                          ? 'flex-row'
                                          : 'flex-col'
                                      } flex justify-between items-center w-full pb-4`}>
                                      <span className="font-normal text-base text-[#364152] w-2/5">
                                        {headerTextForNoPlan && headerTextForNoPlan?.length > 0 ? (
                                          !isSAVFile ? (
                                            <>
                                              Delete the old <br></br>file to continue
                                            </>
                                          ) : (
                                            <>
                                              Convert your file<br></br> to CSV
                                            </>
                                          )
                                        ) : (
                                          <></>
                                        )}
                                      </span>
                                      {headerTextForNoPlan && headerTextForNoPlan?.length > 0 ? (
                                        <span className="font-semibold text-base text-[#364152] w-1/5">
                                          -OR-
                                        </span>
                                      ) : (
                                        <></>
                                      )}

                                      <span
                                        className={`${
                                          headerTextForNoPlan && headerTextForNoPlan?.length > 0
                                            ? 'w-2/5'
                                            : 'w-full flex justify-center'
                                        }`}>
                                        <UpgradePlanText
                                          headerTextForNoPlan={headerTextForNoPlan}
                                          handleClickUpgrade={handleClickUpgrade}
                                          classname={
                                            'flex justify-center flex-col pb-2 pt-2.5 gap-3'
                                          }
                                          noRocketIcon={true}
                                          customText={`${
                                            isSAVFile
                                              ? 'to unlock this <br> and other features'
                                              : headerTextForNoPlan &&
                                                headerTextForNoPlan?.length > 0
                                              ? 'for <br> unlimited files'
                                              : 'to unlock this and other features'
                                          }`}
                                          isShortened={true}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="flex flex-col justify-center gap-6 text-center pb-12">
                                    <span className="font-bold text-base text-[#364152] pt-4">
                                      We encountered a problem
                                    </span>
                                    <span className="text-base text-[#364152] pt-5 pb-12">
                                      To upload this file please contact us at <br></br>
                                      <span
                                        className="text-[#1C8CA6] font-bold cursor-pointer underline underline-offset-4"
                                        onClick={handleOpenEmail}>
                                        support@drumroll.ai
                                      </span>{' '}
                                    </span>
                                  </div>
                                </>
                              )
                            ) : !isGenericError ? (
                              <>
                                <div className="flex justify-center">
                                  <span
                                    className={`${
                                      headerTextForNoPlan ? 'text-xl' : '2xl:text-base text-sm'
                                    } text-light-black font-bold mt-2.5`}>
                                    {headerTextForNoPlan ? (
                                      headerTextForNoPlan !== 'upgrade' ? (
                                        headerTextForNoPlan
                                      ) : (
                                        <UpgradePlanText
                                          textclass="text-xl"
                                          classname={'flex justify-center pb-7 pt-2'}
                                        />
                                      )
                                    ) : (
                                      'Something went wrong. Please address the following issue:'
                                    )}
                                  </span>
                                </div>

                                <div className="flex justify-center flex-col mt-4 mb-8">
                                  <span
                                    className={`${
                                      showMore
                                        ? 'overflow-auto 2xl:max-h-[291px] max-h-[191px]'
                                        : 'line-clamp-2'
                                    } text-light-black 2xl:text-sm text-xs text-center`}>
                                    {error}
                                  </span>

                                  {error && error.length > 160 && (
                                    <span
                                      onClick={() => setShowMore(!showMore)}
                                      className="text-[#098BAA] 2xl:text-xs text-[11px] mt-1 flex justify-end underline cursor-pointer mr-4 2xl:mr-[22.5px]">
                                      {showMore ? 'Show less' : 'Show more'}
                                    </span>
                                  )}
                                </div>

                                <div className="flex flex-col mb-8 justify-center">
                                  {error && (
                                    <>
                                      <span className="text-[#364152] 2xl:text-base text-sm mb-5 mt-2.5 text-center">
                                        Questions or help formatting your file?{' '}
                                      </span>
                                      <div className="flex flex-row justify-center items-center">
                                        <span className="text-[#1C8CA6] 2xl:text-base text-sm font-bold">
                                          Contact us in our messager
                                        </span>
                                        <img
                                          src="/icons/chat-contact.svg"
                                          className="mx-2.5"
                                          alt="Chat"
                                        />
                                        <span className="text-[#1C8CA6] 2xl:text-base text-sm font-bold">
                                          or at support@drumroll.ai
                                        </span>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            ) : showGenericError ? (
                              <>
                                <div
                                  className={`pb-7 flex flex-col justify-center gap-6 text-center`}>
                                  <div className="text-[#364152] pb-16 flex flex-col gap-2">
                                    <>
                                      <span className="font-bold text-[#364152] pt-4">
                                        Oops! Something went wrong
                                      </span>
                                      <span className="pt-5 text-[#364152]">
                                        Please try again later or contact
                                      </span>
                                      <span
                                        className="text-[#1C8CA6] -mt-1 font-semibold cursor-pointer underline underline-offset-4"
                                        onClick={handleOpenEmail}>
                                        support@drumroll.ai
                                      </span>{' '}
                                    </>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="flex flex-col justify-center gap-6 text-center pb-12">
                                  <span className="font-bold text-base text-[#364152] pt-4">
                                    We encountered a problem
                                  </span>
                                  <div className="flex flex-row gap-4 justify-center">
                                    <div>
                                      <img
                                        src="/icons/warning-upload.svg"
                                        className=""
                                        alt="Candle"
                                      />
                                    </div>
                                    <span className="font-normal text-base text-[#364152]">
                                      {headerTextForNoPlan && headerTextForNoPlan?.length > 0 ? (
                                        <>{headerTextForNoPlan}</>
                                      ) : (
                                        <>Looks like this file is not formatted correctly.</>
                                      )}
                                    </span>
                                  </div>

                                  <div className="flex flex-row justify-between items-start w-full px-12 pt-1 gap-2 pb-8">
                                    <span className="font-normal text-base text-[#364152] w-3/6">
                                      <div className="flex flex-col gap-1 text-start justify-start">
                                        <span className="font-semibold text-xs pb-2">
                                          The file must look like this:
                                        </span>
                                        <div>
                                          <img
                                            src="/img/excel-upload.svg"
                                            alt="Excel"
                                            className=""
                                          />
                                        </div>
                                      </div>
                                    </span>

                                    <span className="w-3/6 pl-5 pt-3">
                                      <div className="bg-[#D9D9D933] rounded-[15px] pt-1.5 pb-2.5 border-[1px] border-solid border-[#788AA6]">
                                        <div className="flex flex-col gap-1 items-start">
                                          <ul
                                            className="list-disc ml-8"
                                            style={{ textAlign: 'start' }}>
                                            <li>
                                              <span className="text-[#000000] text-xs">
                                                CSV, XSLX or SAV files only
                                              </span>
                                            </li>
                                            <li>
                                              <span className="text-[#000000] text-xs">
                                                Header in row 1
                                              </span>
                                            </li>
                                            <li>
                                              <span className="text-[#000000] text-xs">
                                                Starting from cell A1
                                              </span>
                                            </li>
                                            <li>
                                              <span className="text-[#000000] text-xs">
                                                Nothing above, below or on the sides
                                              </span>
                                            </li>
                                            <li>
                                              <span className="text-[#000000] text-xs">
                                                No unnamed or merged columns
                                              </span>
                                            </li>
                                            <li>
                                              <span className="text-[#000000] text-xs">
                                                No hidden columns
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </span>
                                  </div>

                                  <ContactInfo />
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </>
      )}

      {showVideoModal && <VideoModal openModal={showVideoModal} setOpenModal={setShowVideoModal} />}
    </>
  );
};
